import { Table } from "@/features/Table";
import { type A9StaticDatum, porfolios_columns } from "./columns";
import {
  type FilterA9StaticDatumsSchema,
  FilterA9StaticDatums,
} from "./filter";

const client = "a9";
const table_name = "a9_static_data";

export const A9StaticDatumsTable = () => {
  return (
    <Table<A9StaticDatum, FilterA9StaticDatumsSchema>
      label="Actifs"
      client={client}
      table_name={table_name}
      columns={porfolios_columns}
      filter={<FilterA9StaticDatums />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
